module.exports = __webpack_public_path__ + "static/img/ppdh.5fdc3e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ppdh.png
// module id = QH8I
// module chunks = 0